/**
 * Record Detail Page
 *
 * Shows detailed view of a single entity record.
 */

import { Typography, useI18n } from '@ops-matrix/design-system-ui';
import { useNavigate, useParams } from 'react-router-dom';
import EntityRecordDetail from '../../components/entity/EntityRecordDetail';
import { PageTemplate } from '../../components/layout/PageTemplate';

export default function RecordDetailPage() {
  const { entityId, recordId } = useParams<{ entityId: string; recordId: string }>();
  const navigate = useNavigate();
  const { t } = useI18n();

  if (!entityId || !recordId) {
    return (
      <PageTemplate variant="detail">
        <Typography color="error" sx={{ textAlign: 'center', py: 4 }}>
          {t('consumer.record.notFound')}
        </Typography>
      </PageTemplate>
    );
  }

  const handleEdit = () => {
    navigate(`/records/${entityId}/${recordId}/edit`);
  };

  return (
    <PageTemplate variant="detail">
      <EntityRecordDetail entityId={entityId} recordId={recordId} onEdit={handleEdit} />
    </PageTemplate>
  );
}
